module.exports = __webpack_public_path__ + "static/media/Login.543ca625.png";